module.exports = __webpack_public_path__ + "static/media/Apple LiGothic Medium.7d4c5142.svg";